// lib
import { useContext } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/sidebar/filters/FiltersPanel'

// components
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'

import AdvancedFilterContainer from '@aytm/app/stats/components/advanced-filter/AdvancedFilterContainer'

// styles
import style from '@aytm/app/stats/page/sidebar/filters/styles/FiltersPanel.module.scss'

const FiltersAdvanced = ({ parser, surveySchema, clusters, parserResultEof }) => {
  const { root, features, state, onAdvancedFilterChange } = useContext(DataContext)

  return (
    <div data-testid="stat-filters-advanced" className={`${style['advanced-container']} p-col-12`}>
      <div className={style['filter-header']}>
        <span data-testid="stat-filters-advanced-title" className={style['filter-title']}>
          Custom filters
        </span>
        {root && (
          <SidebarPopup
            root={root}
            help='Custom filters give you a greater control over filtering conditions, such as using an "OR" operator, grouping conditions in parentheses etc. You can define your desired filtering criteria using the standard aytm Logic expressions (without square brackets). For example, <b>Q1A1</b> or <b>Q2A1</b>. Option to switch back to the basic mode will be available as long as your filter expression is supported by our user interface. Once filter becomes too complex, you will be able to continue using the advanced mode only.'
          />
        )}
      </div>
      <AdvancedFilterContainer
        dataTestID="stat-filters-advanced-input"
        pattern={state.advanced}
        parser={parser}
        surveySchema={surveySchema}
        clusters={clusters}
        parserResultEof={parserResultEof}
        hintPosition="bottom"
        disabled={features.filters.disabled || features.advanced_filters.disabled}
        onChange={features.filters.disabled || features.advanced_filters.disabled ? null : onAdvancedFilterChange}
      />
    </div>
  )
}

FiltersAdvanced.propTypes = {
  parser: PropTypes.any,
  surveySchema: PropTypes.object,
  clusters: PropTypes.array,
  parserResultEof: PropTypes.object.isRequired
}

FiltersAdvanced.displayName = 'FiltersAdvanced'

export default FiltersAdvanced
